import { Route } from '@angular/router';
import { ImpressionsComponent } from 'src/app/pages/network/location-details/impressions/impressions.component';
import { LocationDetailsComponent } from 'src/app/pages/network/location-details/location-details.component';
import { LocationDevicesComponent } from 'src/app/pages/network/location-details/location-devices/location-devices.component';
import { LocationOverviewComponent } from 'src/app/pages/network/location-details/location-overview/location-overview.component';
import { LocationSettingsComponent } from 'src/app/pages/network/location-details/location-settings/location-settings.component';
import { LocationStatisticsVisitorComponent } from 'src/app/pages/network/location-details/location-statistics-visitor/location-statistics-visitor.component';
import { ThreeDimensionalImpressionComponent } from 'src/app/pages/network/location-details/three-dimensional-impression/three-dimensional-impression.component';
import { LocationEditComponent } from 'src/app/pages/network/locations/location-edit/location-edit.component';
import { LocationsComponent } from 'src/app/pages/network/locations/locations.component';
import { RouteGuardService } from 'src/app/services/route-guard.service';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { LocationTrackerComponent } from '../../../../../pages/network/location-details/location-tracker/location-tracker.component';
import { LocationTrackerAssignmentComponent } from 'src/app/pages/network/location-details/location-tracker-assignment/location-tracker-assignment.component';
import { LocationAttachmentsComponent } from '../../../../../pages/network/location-details/location-attachments/location-attachments.component';

export const locations: Route = {
  path: 'locations',
  title: 'nav.network.locations',
  data: {
    breadcrumb: 'nav.network.locations',
    icon: SbIcons.location,
    id: RoutingID.locations,
  },
  children: [
    {
      path: '',
      component: LocationsComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'location-edit/:locationID',
      title: 'nav.network.locations.edit',
      data: {
        breadcrumb: 'nav.network.locations.edit',
        icon: SbIcons.edit,
        id: RoutingID.locationEdit,
      },
      children: [
        {
          path: '',
          canDeactivate: [RouteGuardService],
          component: LocationEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'location-create',
      title: 'nav.network.locations.create',
      data: {
        breadcrumb: 'nav.network.locations.create',
        icon: SbIcons.plus,
        id: RoutingID.locationCreate,
      },
      children: [
        {
          path: '',
          canDeactivate: [RouteGuardService],
          component: LocationEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'location-details/:locationID',
      title: 'nav.network.locations.details',
      data: {
        breadcrumb: 'nav.network.locations.details',
        icon: SbIcons.details,
        id: RoutingID.locationDetails,
      },
      children: [
        {
          path: '',
          component: LocationDetailsComponent,
          data: {
            breadcrumb: '',
          },
          children: [
            {
              path: 'location-details-overview',
              component: LocationOverviewComponent,
              data: {
                breadcrumb: '',
                id: RoutingID.locationDetailsOverview,
              },
            },
            {
              path: 'location-details-statistics-visitor',
              component: LocationStatisticsVisitorComponent,
              data: {
                breadcrumb: '',
                id: RoutingID.locationDetailsStatisticsVisitor,
              },
            },
            {
              path: 'location-details-tracker',
              component: LocationTrackerComponent,
              data: {
                breadcrumb: '',
                id: RoutingID.locationDetailsTracker,
              },
            },
            {
              path: 'location-details-tracker-assignment',
              component: LocationTrackerAssignmentComponent,
              data: {
                breadcrumb: '',
                id: RoutingID.locationDetailsTrackerAssignment,
              },
            },
            {
              path: 'location-details-devices',
              component: LocationDevicesComponent,
              data: {
                breadcrumb: '',
                id: RoutingID.locationDetailsDevices,
              },
            },
            {
              path: 'location-details-settings',
              component: LocationSettingsComponent,
              data: {
                breadcrumb: '',
                id: RoutingID.locationDetailsSettings,
              },
            },
            {
              path: 'location-details-views',
              component: ImpressionsComponent,
              data: {
                breadcrumb: '',
                id: RoutingID.locationDetailsViews,
              },
            },
            {
              path: 'location-details-three-dimensional-view',
              component: ThreeDimensionalImpressionComponent,
              data: {
                breadcrumb: '',
                id: RoutingID.locationDetailsThreeDimensionalView,
              },
            },
            {
              path: 'location-details-attachments',
              component: LocationAttachmentsComponent,
              data: {
                breadcrumb: '',
                id: RoutingID.locationDetailsAttachments,
              },
            },
            { path: '', redirectTo: RoutingID.locationDetailsOverview, pathMatch: 'full' },
          ],
        },
      ],
    },
  ],
};
